export default {
	navbar: {
		home: '数据概览',
		login: {
			reset: '修改密码',
			logOut: '退出登录',
			version: '版本信息'
		},
		notice: {
			logOut: {
				title: '系统提示',
				message: '确认退出登录？',
				confirm: '立即退出',
				cancel: '暂不退出',
			}
		}
	},
	navMenu: {
		dashboard: '数据概览',
		develop: '开发者',
		developItem: {
			device: '设备列表',
			app: '个人应用',
			appstore: '应用商店',
		},
		stock: '库存管理',
		stockItem: {
			record: '库存记录',
			expired: '库存过期',
			set: '库存设置',
		},
		log: '日志管理',
		logItem: {
			report: '上报日志',
			operate: '操作日志',
			login: '登录日志',
		},
		store: 'JOSH Store',
		storeItem: {
			recommend: '首页推荐',
			demand: '需求管理',
			app: '应用管理'
		},
		user: '用户管理',
		userItem: {
			allUser: '所有用户',
			visualUser: '可视化用户',
			blocklUser: '区块链用户',
			logUser: '日志用户',
		},
		visual: '可视化管理',
		visualItem: {
			visualType: '可视化类型',
			visualPage: '可视化页面',
		},
		block: '区块链管理',
		blockItem: {
			blockPage: '区块链',
			blockMap: '数据账户映射',
			blockContract: '合约地址'
		},
		test: '测试管理',
		account: '运维管理',
		suggest: '意见反馈',
		config: '配置管理',
		configItem: {
			type: '设备类型'
		},
		ams: 'AMS管理',
		order: '订单管理',
		orderItem: {
			orderPage: '订单',
			notifyPage: '微信回调',
		},
		invoice: '发票管理',
		invoiceItem: {
			invoicePage: '开票列表',
			infoPage: '开票信息',
			managerPage: '开票管理员'
		},
		applicationtype:'应用类型管理',
		Invertermanagement:'逆变器管理',
		InvertermanagementItem:{
			InvertermanagementIndex:'逆变器类型列表',
			UserList:'逆变器企业用户列表',
			Invertermodel:'逆变器型号列表',
			InverterInformation:'逆变器应用信息列表',
		},
		collectionrod:'采集棒平台管理',
		
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh.js